import ProductModal from './components/ProductModal.vue'
import Checkout from './components/views/Checkout.vue'
//import Home from './components/views/Home.vue'
import Home from './components/views/Home.vue'
import Payment from './components/views/Payment.vue'
import Producto from './components/views/Producto.vue'
import politicasDatos from './components/views/PoliticasDatos.vue'
// import Products from './components/Products.vue'
import Store from './components/views/Store.vue'
import ContactoView from './components/views/ContactoView.vue'
import Nosotros from './components/views/Nosotros.vue'


    const routes = [
        { path: '/', 
        component: Home,
        name: 'home',
        children:[
            {
                path: '/product/:id',
                component: ProductModal,
                name: 'product',
            }]
       },
       {
        path: '/tienda/:id',
        component: Store,
        name: 'tienda',
       },
       {
        path: '/politicas',
        component: politicasDatos,
        name: 'tienda',
       },
       {
         path: '/nosotros',
         component: Nosotros,
         name: 'nosotros',
       },
       {
         path: '/contacto',
         component: ContactoView,
         name: 'contacto',
       },
       {
           path: '/checkout',
           component: Checkout,
           name: 'checkout',
       },
       {
        path: '/tienda',
        component: Store,
        name: 'store',
        },
        {
            path: '/payment',
            component: Payment,
            name: 'payment',
        },
        {
            path: '/producto/:id',
            component: Producto,
            name: 'producto',
        },
       
        { path: '*', redirect: '/' }
        // { path: '/bar',  component: Bar }
    
        // {
        //   path: '/coins/:id',
        //   name: 'Coins',
        //   component: Coins
        // }
      ]

export default routes